var $e59d2e4af9ff1c28$exports = {};
$e59d2e4af9ff1c28$exports = {
    "(optional)": `(facoltativo)`,
    "(required)": `(obbligatorio)`
};


export {$e59d2e4af9ff1c28$exports as default};
//# sourceMappingURL=it-IT.module.js.map
